export default class AbilitySelector {
  constructor(data, entity_name) {
    this.entity_name = entity_name;
    this.select_data = data;
    this.init_checked();
    this.events_handler();
  }

  init_checked() {
    this.init_selected_for($(`#${this.entity_name}_additional_abilities_select_department`), 'departments');
    this.init_selected_for($(`#${this.entity_name}_additional_abilities_select_location`), 'locations');
    this.init_selected_for($(`#${this.entity_name}_additional_abilities_select_unit`), 'units');
    this.init_selected_for($(`#${this.entity_name}_additional_abilities_select_project`), 'projects');
  }

  init_selected_for(element, name) {
    let select = this.build_select(name, this.select_data[name], this.select_data["selected_" + name]);
    if (element.is(":checked")) {
      if (element.parents('span').find('select').length === 0) {
        element.parents('span').append(select);
        select.select2();
      }
    } else {
      if (element.parents('span').find('select').length > 0) {
        element.parents('span').find('select').remove();
        element.parents('span').find('.select2-container').remove();
      }
    }
  }


  build_select(name, items, selected) {
    let select = $('<select/>', {
      id: `${this.entity_name}_related_${name}`,
      name: `${this.entity_name}[related_${name}][]`,
      multiple: 'multiple',
      class: "select optional form-control"
    });
    $.each(items, function(index, value) {
      $('<option/>', {
        text: value[0],
        selected: $.inArray(value[1], selected) !== -1 ? 'selected' : void 0,
        val: value[1]
      }).appendTo(select);
    });
    return select;
  };

  events_handler() {
    $(document).on('click', `#${this.entity_name}_additional_abilities_select_department,
                             #${this.entity_name}_additional_abilities_select_project,
                             #${this.entity_name}_additional_abilities_select_unit,
                             #${this.entity_name}_additional_abilities_select_location`, () => this.init_checked());
  }

}
